import { inject, Injectable } from '@angular/core';
import { IDashboardApiService } from './dashboard-api.interface';
import { ProductsApiService } from '../products/products-api.service';
import { FindNetRevenueOverTimeQueryDto } from './dtos/find-net-revenue-over-time.query.dto';
import { FindNetRevenueOverTimeResponseDto } from './dtos/find-net-revenue-over-time.response.dto';
import { FindTop10BestSellersQueryDto } from './dtos/find-top-10-best-sellers.query.dto';
import { FindTop10BestSellersResponseDto } from './dtos/find-top-10-best-sellers.response.dto';
import { FindSalesSummaryResponseDto } from './dtos/find-sales-summary-response.dto';
import { FindSalesSummaryQueryDto } from './dtos/find-sales-summary.query.dto';
import { FindStoreInsightsQueryDto } from './dtos/find-store-insights.query.dto';
import { FindStoreInsightsResponseDto } from './dtos/find-store-insights.response.dto';

@Injectable({
  providedIn: 'root',
})
export class DashboardMockApiService implements IDashboardApiService {
  productsService = inject(ProductsApiService);

  findSalesSummary(
    dto: FindSalesSummaryQueryDto
  ): Promise<FindSalesSummaryResponseDto> {
    throw new Error('Method not implemented.');
  }

  findNetRevenueOverTime(
    dto: FindNetRevenueOverTimeQueryDto
  ): Promise<FindNetRevenueOverTimeResponseDto> {
    throw new Error('Method not implemented.');
  }

  findTop10BestSellers(
    dto: FindTop10BestSellersQueryDto
  ): Promise<FindTop10BestSellersResponseDto> {
    throw new Error('Method not implemented.');
  }

  findStoreInsights(
    dto: FindStoreInsightsQueryDto
  ): Promise<FindStoreInsightsResponseDto> {
    throw new Error('Method not implemented.');
  }
}
